import { Link } from "gatsby";
import styled from "styled-components";
import { CaptionSemiboldStyle } from "storybook-components/Typography";

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 32px auto 24px;
`;

export const PaginationLink = styled(Link)`
  width: 32px;
  height: 32px;
  margin: 0 6px;
  padding: 6px;
  ${CaptionSemiboldStyle}
  color: ${({ theme }) => theme.colors.green5};
  background-color: ${({ theme }) => theme.colors.gray1};
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  &:hover {
    color: ${({ theme }) => theme.colors.green1};
    background-color: ${({ theme }) => theme.colors.green4};
    text-decoration: none;
    path {
      fill: ${({ theme }) => theme.colors.green1};
    }
  }
  &.current-page {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.green2};
    background-color: ${({ theme }) => theme.colors.green5};
  }

  &.disabled {
    /* https://caniuse.com/#feat=pointer-events */
    pointer-events: none;
  }

  &.hide-on-mobile {
    display: none;
    ${props => props.theme.media.phoneUp`
      display: block;
    `};
  }
`;
export const StepperWrapper = styled.div`
  display: flex;
  margin: 0 1rem;
`;
